import { grey } from "@faro-lotv/flat-ui";
import { Box } from "@mui/material";
import { type JSX, type PropsWithChildren } from "react";

/**
 * @returns a keyboard key rendered as a key cap, for the one-line hints of the tool banners.
 * TODO PDI-458: same as the Key of the SWEB-9035 measurement guidance, use that one once merged.
 */
export function KeyCap({ children }: PropsWithChildren): JSX.Element {
  return (
    <Box
      component="kbd"
      sx={{
        px: 0.75,
        mx: 0.25,
        border: `1px solid ${grey[500]}`,
        borderRadius: "4px",
        fontFamily: "inherit",
        fontSize: "0.85em",
        fontWeight: "bold",
      }}
    >
      {children}
    </Box>
  );
}
